import script from "./EmptyAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyAssets.vue?vue&type=script&setup=true&lang=js"

import "./EmptyAssets.vue?vue&type=style&index=0&id=612cbd9e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-612cbd9e"]])

export default __exports__